import React from 'react';
import classnames from 'classnames';
import { LazyImg } from 'src/hooks/useLazyLoad';
import { CustomLink } from 'src/components/CustomLink/CustomLink';
import { Arrow } from 'src/elements/Carousel/settings';
import { ImageAndText } from 'src/elements/ImageAndText/ImageAndText';

import classes from './CarouselWithOrangeBlock.scss';

type CarouselWithOrangeBlockProps = {
    orangeTitle: string;
    title?: string;
    additionalBlock?: boolean;
    elements: {
        link: string;
        title: string;
        image: string;
        widget_title?: string;
    }[];
    withoutTitle?: boolean;
    orangeBlockLink?: string;
};

const carouselSettings = {
    infinite: false,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 1,
    initialSlide: 0,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
            },
        },
    ],
    nextArrow: <Arrow direction="right" color="orange" />,
    prevArrow: <Arrow direction="left" />,
};

export const CarouselWithOrangeBlock: React.FC<CarouselWithOrangeBlockProps> = ({
    orangeTitle,
    title,
    additionalBlock = false,
    elements,
    withoutTitle = false,
    orangeBlockLink,
}) => {
    return (
        <>
            {title && <h3 className={classes.title}>{title}</h3>}
            <div className={classes.categories}>
                <div className={classes.categoryDesktop}>
                    <a
                        className={classnames(classes.categoryBlock, classes.orange)}
                        href={orangeBlockLink && orangeBlockLink}
                    >
                        <h2 className={classes.orangeTitle}>{orangeTitle}</h2>
                    </a>
                    {elements.slice(0, 7).map((element, index) =>
                        withoutTitle ? (
                            <ImageAndText
                                key={`${element.link}-${index}`}
                                link={element.link}
                                image={element.image}
                                paddingFullWithoutBottom={Boolean(element.title)}
                                withoutBackground
                                fullHeight
                            />
                        ) : (
                            <CustomLink
                                link={element.link}
                                className={classnames(classes.categoryBlock)}
                                key={`${element.link}-${index}`}
                            >
                                <p>
                                    <span>{element.title}</span>
                                    <img src="../../../static/icons/v-right_orange.svg" alt="" />
                                </p>
                                <LazyImg className={classes.image} src={element.image} alt={element.title} />
                            </CustomLink>
                        ),
                    )}
                </div>
                <div className={classes.categoryMobile}>
                    {elements.map((element, index) => (
                        <CustomLink
                            link={element.link}
                            className={classnames(classes.categoryBlock, {
                                [classes.noPadding]: element.widget_title?.includes('no-padding'),
                            })}
                            key={`${element.link}-${index}`}
                        >
                            <div className={classes.categoryBlockContent}>
                                <LazyImg className={classes.image} src={element.image} alt={element.title} />
                            </div>
                            <p>{element.title}</p>
                        </CustomLink>
                    ))}
                </div>
            </div>
        </>
    );
};
